import { LIFE_TEST_ID } from '../models/life-check';

/**
 * Monta `images` / `images_pol_proof` para POL estática (NIF-822).
 *
 * Orden: [buffer0, selfieOficial, buffer1?] para que el índice 1 sea la selfie
 * oficial (el back usa `images[1]` cuando existe para age/fraud).
 */
export function buildManualPolImagesPayload(
	officialSelfie: string | null | undefined,
	silentFrames: readonly string[],
): { images: string[]; images_pol_proof: Array<string | null> } {
	if (!officialSelfie) {
		return { images: [], images_pol_proof: [] };
	}

	const frames = silentFrames.filter((f): f is string => typeof f === 'string' && f.length > 0);
	const images: string[] = [];
	const images_pol_proof: Array<string | null> = [];

	if (frames.length === 0) {
		images.push(officialSelfie);
		images_pol_proof.push(LIFE_TEST_ID.GENERAL);
		return { images, images_pol_proof };
	}

	images.push(frames[0]);
	images_pol_proof.push(null);

	images.push(officialSelfie);
	images_pol_proof.push(LIFE_TEST_ID.GENERAL);

	if (frames.length > 1) {
		images.push(frames[1]);
		images_pol_proof.push(null);
	}

	return { images, images_pol_proof };
}
